"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhancements = exports.enhancementsConfig = exports.PickAxeEnhancement = exports.enhancementRanges = void 0;
const types_1 = require("./types");
const attributes_1 = require("./attributes");
const utils_1 = require("./utils");
const tier_1 = require("./tier");
exports.enhancementRanges = {
    [types_1.CoinPickAxeTier.Common]: [1, 3],
    [types_1.CoinPickAxeTier.Uncommon]: [3, 5],
    [types_1.CoinPickAxeTier.Rare]: [5, 7],
    [types_1.CoinPickAxeTier.Epic]: [7, 9],
    [types_1.CoinPickAxeTier.Legendary]: [9, 10],
};
class PickAxeEnhancement {
    constructor(config) {
        this.config = config;
        this.rankingMax = pickAxeEnhancementMaxRank(config.parts);
        this.rankingFns = attributes_1.CoinPickAxeAttributes.attrNumFns(config.parts);
    }
    get name() {
        return this.config.name;
    }
    get color() {
        return this.config.color;
    }
    get icon() {
        return this.config.icon;
    }
    range(dna) {
        const tier = (0, tier_1.getAxeTier)(dna);
        const range = this.config.ranges[tier];
        if (typeof range === 'number')
            return [range, range];
        return range;
    }
    max(dna) {
        const tier = (0, tier_1.getAxeTier)(dna);
        return this.rankingMax[tier];
    }
    score(dna) {
        const rankings = this.rankingFns.map(fn => fn(dna));
        return pickAxeEnhancementRank(rankings);
    }
    percent(dna) {
        return this.score(dna) / this.max(dna);
    }
    benefit(dna) {
        const range = this.range(dna);
        return this.percent(dna) * (range[1] - range[0]) + range[0];
    }
    benefitFormat(dna) {
        const formatted = (0, utils_1.formatNumber)(this.benefit(dna));
        if (this.config.type === 'percent')
            return `+${formatted}%`;
        return formatted;
    }
    benefitComparison(dna1, dna2) {
        const benefit1 = this.benefit(dna1);
        const benefit2 = this.benefit(dna2);
        const difference = benefit2 - benefit1;
        const formatted = (0, utils_1.formatNumber)(difference);
        if (this.config.type === 'percent') {
            const positive = difference > 0 ? '+' : '';
            return `${positive}${formatted}%`;
        }
        return formatted;
    }
    localMax(dna) {
        return this.range(dna)[1];
    }
    globalMax() {
        const range = this.config.ranges[types_1.CoinPickAxeTier.Legendary];
        if (typeof range === 'number')
            return range;
        return range[1];
    }
    description(dna) {
        const n = this.benefitFormat(dna);
        return this.config.description.replace(/{n}/g, n);
    }
    pieces(dna) {
        return this.config.parts.map((part) => {
            const index = attributes_1.CoinPickAxeAttributes.indexOf(part);
            const value = attributes_1.CoinPickAxeAttributes.attrFn(part)(dna);
            const attr = attributes_1.pickAxeAttributes[index];
            const tier = types_1.CoinPickAxeTier[(0, tier_1.getAxeTier)(dna)];
            return {
                trait_type: attr.trait_type,
                max: (0, utils_1.enumMax)(attr.values[tier]),
                score: Number(dna[index]),
                value,
            };
        });
    }
}
exports.PickAxeEnhancement = PickAxeEnhancement;
exports.enhancementsConfig = {
    teamLiftRewards: {
        name: "Team Lift",
        description: "{n} Team Lift Rewards",
        color: '#fdf2cc',
        parts: [types_1.CoinPickAxeValues.HandleMaterial],
        ranges: Object.assign(Object.assign({}, exports.enhancementRanges), { [types_1.CoinPickAxeTier.Rare]: [6, 6], [types_1.CoinPickAxeTier.Epic]: [8, 8], [types_1.CoinPickAxeTier.Legendary]: [10, 10] }),
        type: 'percent',
        icon: 'teamLiftGroup'
    },
    bigGeomineLuck: {
        name: "Big Geomines",
        description: "{n} Big Geomine Luck",
        color: '#dbdbdb',
        parts: [types_1.CoinPickAxeValues.GemShape, types_1.CoinPickAxeValues.GemColor],
        ranges: exports.enhancementRanges,
        type: 'percent',
        icon: 'bigGeomineStars'
    },
    tileClearingEase: {
        name: "Tile Clearing",
        description: "{n} Tile Clearing Ease",
        color: '#fce4d6',
        parts: [types_1.CoinPickAxeValues.BaseFlairShape, types_1.CoinPickAxeValues.BaseFlairColor],
        ranges: Object.assign(Object.assign({}, exports.enhancementRanges), { [types_1.CoinPickAxeTier.Epic]: [8, 9] }),
        type: 'percent',
        icon: 'proofOfWork'
    },
    geominingBoost: {
        name: "Geomining Rewards",
        description: "{n} Geomining Rewards",
        color: '#e1efda',
        parts: [types_1.CoinPickAxeValues.BladeStyle],
        ranges: exports.enhancementRanges,
        type: 'percent',
        icon: 'geominingCircle'
    },
    homeBase: {
        name: "Home Base",
        description: "{n} Home Base Rewards",
        color: '#deeaf7',
        parts: [types_1.CoinPickAxeValues.BaseTopStyle, types_1.CoinPickAxeValues.BaseStyle, types_1.CoinPickAxeValues.BaseColor],
        ranges: exports.enhancementRanges,
        type: 'percent',
        icon: 'homeBaseCircle'
    },
    witnessRewards: {
        name: "Witness Rewards",
        description: "{n} Big Geomine Witness Rewards",
        color: '#b4c6e7',
        parts: [types_1.CoinPickAxeValues.RingShape, types_1.CoinPickAxeValues.RingColor],
        ranges: Object.assign(Object.assign({}, exports.enhancementRanges), { [types_1.CoinPickAxeTier.Legendary]: [10, 10] }),
        type: 'percent',
        icon: 'bigGeomineWitness'
    },
    speedBoost: {
        name: "Speed Boost",
        description: "{n} Geomining Speed Boost",
        color: '#c6e0b4',
        parts: [types_1.CoinPickAxeValues.BladeDetail],
        ranges: Object.assign(Object.assign({}, exports.enhancementRanges), { [types_1.CoinPickAxeTier.Epic]: [8, 9], [types_1.CoinPickAxeTier.Legendary]: [10, 10] }),
        type: 'percent',
        icon: 'geominingSpeed',
    },
    geomineCharge: {
        name: "Geomine Charge",
        description: "{n} Geomine Charge",
        color: '#fdebd1',
        type: 'number',
        icon: 'geominingRecharge',
        parts: [],
        ranges: {
            [types_1.CoinPickAxeTier.Common]: 100000,
            [types_1.CoinPickAxeTier.Uncommon]: 250000,
            [types_1.CoinPickAxeTier.Rare]: 500000,
            [types_1.CoinPickAxeTier.Epic]: 750000,
            [types_1.CoinPickAxeTier.Legendary]: 1000000,
        }
    }
};
const images = {
    "bigGeomineLuck": { ios: "bigGeomineStars", android: "big_geomine_stars" },
    "teamLiftRewards": { ios: "teamLiftGroup", android: "team_lift_group" },
    "tileClearingEase": { ios: "proofOfWork", android: "proof_of_work" },
    "geominingBoost": { ios: "geominingCircle", android: "geomining_circle" },
    "homeBase": { ios: "homeBaseCircle", android: "home_base_circle" },
    "witnessRewards": { ios: "bigGeomineWitness", android: "big_geomine_witness" },
    "speedBoost": { ios: "geominingSpeed", android: "geomining_speed" },
    "geomineCharge": { ios: "geominingRecharge", android: "geomining_recharge" }
};
exports.enhancements = {};
for (const key in exports.enhancementsConfig) {
    exports.enhancements[key] = new PickAxeEnhancement(exports.enhancementsConfig[key]);
}
function pickAxeEnhancementMaxRank(parts) {
    return Object.keys(types_1.CoinPickAxeTier).reduce((acc, key) => {
        const values = (0, utils_1.sum)(parts.map(part => (0, utils_1.enumMax)(part[key] || part[types_1.CoinPickAxeTier[key]]))) || 1;
        acc[key] = values;
        return acc;
    }, {});
}
function pickAxeEnhancementRank(rankings) {
    return (0, utils_1.sum)(rankings.map(ranking => ranking));
}
//# sourceMappingURL=enhancements.js.map